import React from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ENTITY_ROUTES = {
  quote: (_, label) => `/quotes/${label}`,
  work_order: (_, label) => `/works/${label}`,
  part: (id) => `/parts/${id}`,
  order: (id) => `/orders/${id}`,
  customer: (id) => `/customers/${id}`,
  shipment: (id) => `/shipping/${id}`,
};

const NotificationParts = ({ parts = [], onNavigate }) => {
  const navigate = useNavigate();

  const handleLinkClick = (part) => {
    const getRoute = ENTITY_ROUTES[part.resourceType];
    if (getRoute) {
      navigate(getRoute(part.resourceId, part.value));
      onNavigate && onNavigate();
    }
  };

  return (
    <Typography
      variant="caption"
      fontSize={12}
      component="span"
      lineHeight="18px"
    >
      {parts.map((part, i) => {
        switch (part.type) {
          case "actor":
            return (
              <Typography
                key={i}
                component="span"
                fontSize={12}
                fontWeight={600}
              >
                {part.value}
              </Typography>
            );
          case "link":
            return (
              <Typography
                key={i}
                component="span"
                fontSize={12}
                fontWeight={500}
                sx={{
                  color: "hubColors.mainFocus",
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" },
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleLinkClick(part);
                }}
              >
                {part.value}
              </Typography>
            );
          case "text":
          default:
            return (
              <Typography
                key={i}
                component="span"
                fontSize={12}
                fontWeight={part?.emphasized ? 800 : 400}
                color="text.secondary"
              >
                {part.value}
              </Typography>
            );
        }
      })}
    </Typography>
  );
};

export default NotificationParts;
